import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { EnvironmentType } from '@root/shared/environment/environment-type';
import { AppRootModule } from './app/app-root/feature/app-root.module';
import { environment } from './environment';

if (EnvironmentType[environment.envType] == EnvironmentType.Production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppRootModule).catch(error => console.error(error));
